/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Pagination from "react-js-pagination";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import formatDateTimeToPST from "../PSTDateConvert";
import Loader from "../Loader";
import Select from 'react-select';
import { getNumberStatusLabel } from '../../utils/inventory';
axios.defaults.timeout = 300000;
 
const InventoryList = () => {
    const location = useLocation();
    const abx = location.state;
    // console.log(abx);
    const [name, setName] = useState('');
    const [timeZone, seTimeZone] = useState('');
    const [cid, seCid] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [inventory, setInventory] = useState([]);
    const [error, setError] = useState(null);
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [numberManagementAccess, setNumberManagementAccess] = useState(true);
    const [userInventoryAccess, setUserInventoryAccess] = useState(true);
    const [userMultipleInventoryAccess, setUserMultipleInventoryAccess] = useState(false);
    const [userManageTagsAccess, setUserManageTagsAccess] = useState(false);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [searchValue, setSearchValue] = useState(abx != null ? abx.searchValue : "");
    const [selectedCompany, setSelectedCompany] = useState(abx != null ? abx.selectedCompany : 0);
    const [selectedCarrier, setSelectedCarrier] = useState(abx != null ? abx.selectedCarrier : "");
    const [selectedEnrmsType, setSelectedEnrmsType] = useState(abx != null ? abx.selectedEnrmsType : "");
    const [selectedType, setSelectedType] = useState(abx != null ? abx.selectedType : "");
    const [status, setStatus] = useState(abx != null ? abx.status : "0");
    const [selectedRoute, setSelectedRoute] = useState(abx != null ? abx.selectedRoute : "");
    const [company, setCompany] = useState([]);
    const [routeList, setRouteList] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [inventoryAccess, setInventoryAccess] = useState(false);
    const [mutipleInventoryAccess, setMutipleInventoryAccess] = useState(false);
    const [isMappingAccessFetched, setIsMappingAccessFetched] = useState(false);
    const [ciaAccess,setCiaAccess] = useState(false)
    const [carriers, setCarriers] = useState([]);
    const [tagsList, setTagsList] = useState([]);
    const [selectedTags, setSelectedTags] = useState(abx != null ? abx.selectedTags : "");
    const [tagOperator, setTagOperator] = useState(abx != null ? abx.tagOperator : 'AND');
    const [hasSearched, setHasSearched] = useState(abx != null); // Auto-restore search when returning from a number detail page


    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
        getUserAccess();
        getUserCompany();
        getCarrierList();
    }, []);
    useEffect(() => {
        if(cid){
            getComapnyRoute();
            getCustomerDigitMappingAccess();
            getTagsList();
        }
    }, [cid, selectedCompany, role]);
    useEffect(() => {
        if(access.length > 0 && token && isMappingAccessFetched){
            checkAccess(access, token);
        }
    }, [access, token, isMappingAccessFetched, numberManagementAccess]);
    useEffect(() => {
        if(role && carriers.length > 0){
            // BBD users (role <= 2): Do NOT auto-load, must click search
            // Customer users (role > 2): Auto-load with their company
            if(role > 2){
                // Customer users: Set default company to their cid and auto-load
                if(!hasSearched && cid){
                    setSelectedCompany(cid);
                    getOrder(page, cid, searchValue, status, selectedRoute, selectedCarrier, selectedType, selectedEnrmsType, selectedTags, tagOperator);
                    setHasSearched(true);
                } else if(hasSearched){
                    // Reload when page changes after initial search
                    getOrder(page, selectedCompany, searchValue, status, selectedRoute, selectedCarrier, selectedType, selectedEnrmsType, selectedTags, tagOperator);
                }
            } else if(role <= 2 && hasSearched){
                // BBD users: Only load if they've clicked search
                getOrder(page, selectedCompany, searchValue, status, selectedRoute, selectedCarrier, selectedType, selectedEnrmsType, selectedTags, tagOperator);
            }
        }
    }, [page, role, carriers, hasSearched]);
 
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            seCid(decoded.cid);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setAccess(response.data.results);
            setNumberManagementAccess(response.data.number_management_switch == 0 ? false : true);
            setUserInventoryAccess(response.data.user_inventory_switch == 0 ? false : true);
            setUserMultipleInventoryAccess(response.data.user_multiple_inventory_switch == 0 ? false : true);
            setUserManageTagsAccess(response.data.user_manage_tags == 0 ? false : true);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    
    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const company = response.data.filter(item => item.id !== 1);
        // company.shift();
        // console.log(response.data);
        setCompany(company);
    }

    const getComapnyRoute = async () => {
        let comapny_id;
        if(cid === 1){
            comapny_id = selectedCompany;
        }else{
            comapny_id = cid;
        }
        // console.log(selectedCompany);
        
        const response = await axiosJWT.get(`${baseUrl}/route-list/${comapny_id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const route = response.data;
        // company.shift();
        // console.log(response.data);
        setRouteList(route.data);
    }

    const handlePageChange  = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
    }
    const getOrder = async (page, cid, search, status, route, carrier, type, enrmsType,  tags, operator) => {
        // console.log(page);
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/inventory?page=${page}&limit=${20}&company=${cid}&search=${search}&status=${status}&route=${route}&carrier=${carrier}&type=${type}&enrmsType=${enrmsType}&tags=${JSON.stringify(tags)}&operator=${operator}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setPopupOpen(false);
        if(role <= 2 && cid && (status === "0" || status === 0 || status == 2)){
            setIsFilter(true);
        }else if(role > 2 && (status === "0" || status === 0)){
            setIsFilter(true);
        }else{
            setIsFilter(false);
        }

        const result = response.data.data;
        const updatedResult = result.map((item) => {
            // Determine the carrier_name based on number_type and carriers list
            const carrier_name = item.status == 3  ? "Bandwidth/VB" : item.number_type == 1
                ? "Bandwidth"
                : item.number_type == 0
                ? "Inteliquent"
                : carriers.filter((carrier) => !["Inteliquent", "Bandwidth"].includes(carrier.name))
                          .find((carrier) => carrier.carrier_index == item.number_type)?.name || "-";
            return {
                ...item, // Spread the original properties of the item
                carrier_name, // Add the carrier_name property
            };
        });

        setInventory(updatedResult);
        setTotalItem(response.data.totalItem);
    }

    const getCarrierList = async () => {
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/carrier-settings?page=${page}&limit=${2000}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setPopupOpen(false);
        setCarriers(response.data.data);
    }
    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
    };

    const checkAccess = async (access) => {
        if(role == 2 && !hasPermission('viewinventory')){
            navigate('/dashboard');
        }else if(role >= 3 && ((!inventoryAccess) || (inventoryAccess && !userInventoryAccess))){
            navigate('/dashboard');
        }        
    }
    const handleComapnyChange = (e) => {
        setSelectedCompany(e.target.value);
        setSelectedTags([]);
        // setPage(1);
        // console.log(e.target.value);
        // getUsers(page,e.target.value, status); // Reset page to 1 when filter changes
    };

    const handleUserTypeChange = (e) => {
        setStatus(e.target.value);
        // setPage(1);
        // console.log(e.target.value);
        // getUsers(page,selectedCompany, e.target.value, ''); // Reset page to 1 when filter changes
    };

    const handleTypeChange = (e) => {
        setSelectedType(e.target.value);
        // setPage(1);
        // console.log(e.target.value);
        // getUsers(page,selectedCompany, e.target.value, ''); // Reset page to 1 when filter changes
    };

    const handleCarrierChange = (e) => {
        setSelectedCarrier(e.target.value);
        // setPage(1);
        // console.log(e.target.value);
        // getUsers(page,selectedCompany, e.target.value, ''); // Reset page to 1 when filter changes
    };

    const handleEnrmsTypeChange = (e) => {
        setSelectedEnrmsType(e.target.value);
        // setPage(1);
        // console.log(e.target.value);
        // getUsers(page,selectedCompany, e.target.value, ''); // Reset page to 1 when filter changes
    };

    const handleRouteOptionChange = (e) => {
        setSelectedRoute(e.target.value);
       
    };

    const clearFilter = () => {
        setStatus("");
        if(role <= 2){
            setSelectedCompany(0);
        } else {
            setSelectedCompany(cid); // Keep customer's company as default
        }
        setSelectedCarrier("");
        setSelectedType("");
        setSelectedRoute('');
        setSearchValue('');
        setSelectedEnrmsType("");
        setPage(1);
        setSelectedItems([]);
        setSelectedTags([]);
        setTagOperator('AND');

        if(role <= 2){
            // BBD users: Reset hasSearched, require them to search again
            setHasSearched(false);
            setInventory([]);
            setTotalItem(0);
        } else {
            // Customer users: Clear and reload with their company
            getOrder(1, cid, '', '', "", "", "", "", "", "");
        }
        setIsFilter(false);
    }

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };
    const handleSearchSubmit = () => {
        setPage(1);
        setSelectedItems([]);

        // If already searched before (hasSearched is true), call getOrder directly
        // because useEffect won't trigger if hasSearched doesn't change
        if(hasSearched) {
            getOrder(1, selectedCompany, searchValue, status, selectedRoute, selectedCarrier, selectedType, selectedEnrmsType, selectedTags, tagOperator);
        } else {
            // First time search - set flag and let useEffect handle it
            setHasSearched(true);
        }
    };

    const buildFilterLabels = () => {
        const parts = [];
        const statusLabels = { '0': 'Active', '1': 'Cancelled', '2': 'Others', '4': 'Upcoming Port', '5': 'Port Failed' };
        const typeLabels = { '0': 'Did', '1': 'Toll Free' };
        const enrmsLabels = { '0': 'Disable', '1': 'Enable' };
        const builtinCarrierLabels = { '0': 'Inteliquent', '1': 'Bandwidth', 'vb': 'Bandwidth/VB' };

        if (status !== '' && status !== null && status !== undefined) {
            parts.push(`Status: ${statusLabels[String(status)] ?? status}`);
        }
        if (selectedType !== '' && selectedType !== null && selectedType !== undefined) {
            parts.push(`Number Type: ${typeLabels[String(selectedType)] ?? selectedType}`);
        }
        if (selectedEnrmsType !== '' && selectedEnrmsType !== null && selectedEnrmsType !== undefined) {
            parts.push(`ENRMS Type: ${enrmsLabels[String(selectedEnrmsType)] ?? selectedEnrmsType}`);
        }
        if (selectedCarrier !== '' && selectedCarrier !== null && selectedCarrier !== undefined) {
            const customCarrier = carriers.find(c => String(c.carrier_index) === String(selectedCarrier))?.name;
            parts.push(`Carrier: ${builtinCarrierLabels[String(selectedCarrier)] ?? customCarrier ?? selectedCarrier}`);
        }
        if (selectedRoute) parts.push(`Route Option: ${selectedRoute}`);
        if (Array.isArray(selectedTags) && selectedTags.length > 0) {
            const tagNames = selectedTags.map(t => t?.label ?? t?.tag_name ?? t?.value ?? t).join(', ');
            parts.push(`Tags: ${tagNames}${selectedTags.length > 1 ? ` (${tagOperator})` : ''}`);
        }
        if (searchValue) parts.push(`Search: ${searchValue}`);
        if (selectedCompany && Number(selectedCompany) !== 0) {
            const compName = company.find(c => String(c.id) === String(selectedCompany))?.cname;
            if (compName) parts.push(`Company: ${compName}`);
        }
        return parts.join(', ');
    };

    const handleExportCSV = async (e) => {
        e.preventDefault();
        setPopupOpen(true);
        try {
            await axiosJWT.post(
                `${baseUrl}/inventory-export/start`,
                {
                    company: selectedCompany,
                    search: searchValue,
                    status: status,
                    route: selectedRoute,
                    type: selectedType,
                    carrier: selectedCarrier,
                    enrms: selectedEnrmsType,
                    tags: JSON.stringify(selectedTags),
                    operator: tagOperator,
                    filters_label: buildFilterLabels(),
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            alert("Your export request is in process. You can check the Inventory Export History page.");
            navigate('/inventory-export-history');
        } catch (error) {
            const msg = error?.response?.data?.message || "Failed to start export. Please try again.";
            alert(msg);
        } finally {
            setPopupOpen(false);
        }
    };
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            seCid(decoded.cid);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const handleNavigation = (e, id, number_type) => {
        e.preventDefault();
        const carrier_name = [0,1].includes(number_type);
        const allArray = {
            selectedCompany:selectedCompany,status: status, searchValue:searchValue, selectedRoute: selectedRoute, selectedCarrier:selectedCarrier,selectedType:selectedType,carrier_name:carrier_name, selectedEnrmsType:selectedEnrmsType, selectedTags:selectedTags, tagOperator:tagOperator
        }
        navigate(`/view-trunk-detail/${btoa(id)}`, { state: allArray });
    };

    const handleCheckboxChange = (item) => {
        const isChecked = selectedItems.some(tnObj => tnObj.tn === item.tn_number);
        if (isChecked) {
            setSelectedItems(prevSelected => prevSelected.filter(tnObj => tnObj.tn !== item.tn_number));
        } else {
            setSelectedItems(prevSelected => [...prevSelected, { tn: item.tn_number, did_order: item.did_order }]);
        }

    };

    const handleTagsChange = (data) => {
        setSelectedTags(data);
    };

    const handleTagOperatorChange = (e) => {
        setTagOperator(e.target.value);
    };

    const getTagsList = async () => {
        try {
            let url = `${baseUrl}/tags-list`;
            let companyIdToFetch = null;

            if (role <= 2) {
                // Admin or Super Admin: Use the filter if a company is selected
                if (selectedCompany && selectedCompany != 0) {
                    companyIdToFetch = selectedCompany;
                }
                // If no company is selected, companyIdToFetch remains null, so all tags are fetched.
            } else if (cid) {
                // Regular user: Always use their own company ID
                companyIdToFetch = cid;
            }
            console.log(companyIdToFetch, "companyIdToFetch");
            if (companyIdToFetch) {
                url += `?cid=${companyIdToFetch}`;
                const response = await axiosJWT.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setTagsList(response.data.data);
            }
            
        } catch (error) {
            console.log(error);
        }
    };

    

    const handleSelectAll = () => {

        if (selectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(inventory.map(tnObj => ({ tn: tnObj.tn_number, did_order: tnObj.did_order })));
        }
        
        setSelectAll(!selectAll);            
    };

    const handleRemoveNumber = async(e) => {
        e.preventDefault();
        // const userConfirmed = window.confirm(`Are you sure you want to remove selected ${selectedItems.length} numbers from the inventory`);
        const userConfirmed = window.confirm("Only use this option to remove a number from the portal.  Doing this will not affect the Sansays or carriers.  If you want to cancel a number, you should use the cancel option. Do you want to continue and only remove this from the portal?");
        if (userConfirmed) {
            setPopupOpen(true);
            // BCP-32: remove source flag - 2 = inventory list. Recorded in the removal history.
            const response = await axiosJWT.post(`${baseUrl}/portal-number-remove`,{numberList: selectedItems, cid:selectedCompany, source: 2}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setPopupOpen(false);
            fetchFilteredData();
            // window.location.reload();
        }
        
    }

    const getCustomerDigitMappingAccess = async () => {
        try {
            // setApiCallCount((prevCount) => prevCount + 1);
            const response = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            console.log(response.data);
          
            setInventoryAccess(response.data.inventory_switch === 1 ? true : false);
            setMutipleInventoryAccess(response.data.multiple_inventory_switch === 1 ? true : false);
            if(response.data.cia_enable_switch === 1){
                if((role > 2 && response.data.cia_account_type == 1) || (role <= 2 && response.data.cia_account_type == 0)){
                    setCiaAccess(true);
                }else{
                    setCiaAccess(false);
                }
            }else{
                setCiaAccess(false);
            }
            setIsMappingAccessFetched(true);
        } catch (error) {
            // setLoading(false);
            
           console.log(error);
            
        }
    };

    const handleEditButtonClick = (e) => {
        e.preventDefault();
        // Determine the trunk filter type based on the did_order of selected numbers.
        // Only routes that support ALL selected number types are shown.
        // did_order: 0=DID, 2=Toll Free, 3=International
        // Backend type: 0=DID only, 1=TFN only, 2=DID+TFN, 3=Intl only,
        //               4=DID+Intl, 5=TFN+Intl, 6=DID+TFN+Intl
        const didOrders = [...new Set(selectedItems.map(i => i.did_order))];
        const hasDID  = didOrders.includes(0);
        const hasTFN  = didOrders.includes(2);
        const hasIntl = didOrders.includes(3);
        let numberType = '';
        if (hasDID && hasTFN && hasIntl) numberType = 6;
        else if (hasDID && hasIntl)      numberType = 4;
        else if (hasTFN && hasIntl)      numberType = 5;
        else if (hasDID && hasTFN)       numberType = 2;
        else if (hasIntl)                numberType = 3;
        else if (hasTFN)                 numberType = 1;
        else if (hasDID)                 numberType = 0;
        navigate(`/edit-multiple-trunk-detail`, { state: {selectedItems: selectedItems, cid:selectedCompany, numberType}});
    }
    
    const handleCiaTypeCommon = async (ciaValue) => {

        const tnNumbers = selectedItems.map(item => item.tn);
        const type = selectedItems.length > 0 ? 1:2;
        let company_id;
        if(role <=2 ){
            company_id = selectedCompany;
        }else{
            company_id = cid;
        }
        const formData = {tnNumbers,ciaValue, type, company_id, status, selectedEnrmsType, selectedType, selectedCarrier, searchValue, selectedRoute, tags: JSON.stringify(selectedTags), operator: tagOperator}

        try{
            const response = await axios.post(`${baseUrl}/update-cas-type/`,{formData : formData}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }      
            });

            if(response.status == 200){
                fetchFilteredData();
                // window.location.reload()
            }

        }catch(error){
            console.log(error)
        }
    }  
    
    const fetchFilteredData = () => {
        const company_id = abx != null ? abx.selectedCompany : selectedCompany;
        const carrier_id = abx != null ? abx.selectedCarrier : selectedCarrier;
        const enrms_type = abx != null ? abx.selectedEnrmsType : selectedEnrmsType;
        const selected_type = abx != null ? abx.selectedType : selectedType;
        const status_value = abx != null ? abx.status : status;
        const route = abx != null ? abx.selectedRoute : selectedRoute;
        const search_value = abx != null ? abx.searchValue : searchValue;
        const tag_value = abx != null ? abx.selectedTags : selectedTags;
        const tag_operator = abx != null ? abx.tagOperator : tagOperator;

        getOrder(page,company_id, search_value, status_value, route, carrier_id, selected_type, enrms_type, tag_value, tag_operator);
    }
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Inventory</h1>
                            </div>
                        </div>
                        <div className="col-6 top-right-buttons">
                        <div className="export-btn newrow"><a className="newrow" onClick={handleExportCSV} href="#">Export</a></div>
                        <div className="export-btn newrow"><a className="newrow" onClick={(e) => { e.preventDefault(); navigate('/inventory-export-history'); }} href="#">Export History</a></div>
                        {/* BCP-32: every removal, from the details page, this list or the import */}
                        {role !== '' && role <= 2 && <div className="export-btn newrow"><a className="newrow" onClick={(e) => { e.preventDefault(); navigate('/removed-numbers-history'); }} href="#">Removed Numbers History</a></div>}
                        {/* {hasPermission("callpassaccess") &&<div className="export-btn newrow"><a className="newrow" href="call-pass-settings">Call Pass Settings</a></div>} */}
                        {/* <div className="export-btn newrow"><a className="newrow"  href="bulk-number-change-route">Bulk Number Change Route</a></div> */}
                        <div className="export-btn addnew-button"><Link to="/number-management"><span>&larr;</span> Back</Link></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-9 order-filter">
                            <div className="boxinput">
                            
                            <input className="search-leave satff-listing-page-search" type="text" name="search" placeholder="Search" value={searchValue} onChange={handleSearchChange} style={{ minWidth: '150px' }} />                      
                            <select className="form-control" name="usertype" value={status} onChange={handleUserTypeChange}>
                                 <option value="" >Status</option>                                    
                                 <option value="0">Active</option>
                                 <option value="1">Cancelled</option>
                                 <option value="2">Others</option>
                                 {role <=2 &&<option value="4">Upcoming Port</option>}
                                 {role <=2 &&<option value="5">Port Failed</option>}
                                
                             </select>
                             
                               {role <=2 && <select className="company-name form-control" name="company" value={selectedCompany} onChange={handleComapnyChange}>
                                    <option value={0} >Company</option>
                                    {company.map((comp, index) => (
                                      <option key={index} value={comp.id}>
                                        {comp.cname}
                                      </option>
                                    ))}
                                </select>
                                 }
                                {/* {role <=2 && selectedCompany != '0' && (<select className="form-control" name="usertype" value={selectedRoute} onChange={handleRouteOptionChange}>
                                 <option value="" >Route Option</option>                                    
                                 {routeList.map((route, index) => (
                                  <option key={index} value={route.value}>
                                    {route.value}
                                  </option>
                                ))}
                                
                             </select>)} */}
                             <select className="form-control" name="number_type" value={selectedType} onChange={handleTypeChange}>
                                 <option value="" >Number Type</option>                                    
                                 <option value="0">Did</option>
                                 <option value="1">Toll Free</option>
                                
                             </select>
                             {role <=2 && <select className="form-control" name="carrier_type" value={selectedCarrier} onChange={handleCarrierChange}>
                                 <option value="" >Carrier Type</option>                                    
                                 <option value="0">Inteliquent</option>
                                 <option value="1">Bandwidth</option>
                                 <option value="vb">Bandwidth/VB</option>
                                 {carriers.filter((item) => !["Inteliquent", "Bandwidth"].includes(item.name)).map((item, index) => (
                                    <option key={index} value={item.carrier_index}>
                                    {item.name}
                                  </option>
                                 ))}
                                
                             </select>}
                             {ciaAccess && <select className="form-control" name="enrms_status" value={selectedEnrmsType} onChange={handleEnrmsTypeChange}>
                                 <option value="" >E-NRMS Type</option>                                    
                                 <option value="0">Disable</option>
                                 <option value="1">Enable</option>
                                
                             </select>}
                             {role >= 3 && (<select className="form-control" name="usertype" value={selectedRoute} onChange={handleRouteOptionChange}>
                                 <option value="" >Route Option</option>                                    
                                 {routeList.map((route, index) => (
                                  <option key={index} value={route.value}>
                                    {route.value}
                                  </option>
                                ))}
                                
                             </select>)}
                                <button  className="search-btn" onClick={handleSearchSubmit}>Search</button>
                               { (selectedCompany || status === 0 || status === "0" || status === "1" || status === "2" || searchValue || selectedRoute || selectedCarrier || selectedType || selectedEnrmsType || selectedTags.length > 0 || (selectedTags && selectedTags.length > 0 && tagOperator)) && (<a className='search-btn clear-btn' onClick={clearFilter} >Clear</a>)}
                            </div>
                            <div className="boxinput" style={{ marginTop: '1rem' }}>                                
                                <Select
                                    classNamePrefix="select"
                                    name="tags"
                                    placeholder="Select Tag"
                                    className='search-select custom-width-20'
                                    onChange={(selectedOption)=>{
                                        handleTagsChange(selectedOption)
                                    }}
                                    value={selectedTags}
                                    options={ tagsList?.map(item => ({
                                        value: item.id,
                                        label: item.tag_name                                                
                                    }))}
                                    isMulti
                                    styles={{
                                        container: (base) => ({
                                          ...base,
                                          marginLeft: "15px"
                                        })
                                      }}

                                />
                                {selectedTags.length > 1 && (
                                    <select className="form-control" name="tag_operator" value={tagOperator} onChange={handleTagOperatorChange}>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                    </select>
                                )}
                            </div>
                        </div>
                        <div className="col-3 top-right-buttons">
                        
                        {role <= 2 && mutipleInventoryAccess && userMultipleInventoryAccess && selectedItems.length > 0 && <div className="export-btn newrow"><a className="newrow" onClick={handleRemoveNumber} href="#">Remove</a></div>}
                        {status != 2 && mutipleInventoryAccess && userMultipleInventoryAccess &&selectedItems.length > 0 && <div className="export-btn addnew-button"><a className='newrow' onClick={handleEditButtonClick}>Edit {selectedItems.length} Numbers</a></div>}
                        {role <= 2 && ciaAccess  && isFilter && <div className='export-btn addnew-button'><a href="#" className='newrow' onClick={() => {handleCiaTypeCommon(true)}}>{selectedItems.length > 0 ? 'Enable E-NRMS' : 'Enable E-NRMS for filtered Tel Number(s)'}</a></div>}
                        {role <= 2 && ciaAccess  && isFilter && <div className='export-btn addnew-button'><a href="#" className='newrow' onClick={() => {handleCiaTypeCommon(false)}}>{selectedItems.length > 0 ? 'Disable E-NRMS' : 'Disable E-NRMS for filtered Tel Number(s)' }</a></div>}

                        </div>
                    </div>
                    
                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                        <div className=" setting-section haft-whitebox">
                            {/* <div className="search-result-section inventory-table">
                                <h3></h3>

                            </div> */}
                            {role <= 2 && !hasSearched && (
                                <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#f8f9fa', borderRadius: '5px', margin: '20px 0' }}>
                                    <h3 style={{ color: '#6c757d', marginBottom: '10px' }}>Please Enter Search Criteria</h3>
                                    <p style={{ color: '#6c757d' }}>Use the filters above and click the "Search" button to load inventory data.</p>
                                </div>
                            )}
                            {(role > 2 || hasSearched) && (
                                <table className="tablebox search-result-table inventory-table">
                                    <thead>
                                        <tr>
                                            {(((mutipleInventoryAccess && userMultipleInventoryAccess) || ciaAccess) && isFilter ) && <th>  <input type="checkbox" className="newrow checkboxAll" onClick={handleSelectAll}  /></th>}
                                           
                                            <th>Tel Number</th>   
                                            <th>Customer Name</th>                                          
                                            {/* <th>Route Option</th> */}
                                            <th>Number Type</th>
                                            {role <=2 && <th>Carrier Type</th>}
                                            <th>Tags</th>
                                            <th>CNAM</th>
                                            {ciaAccess && <th>E-NRMS Type</th>}
                                            {role <=2 && <th>Note</th>}
                                            <th>Created At({timeZone})</th>
                                            <th>Cancelled At({timeZone})</th>
                                            <th>Status</th>
                                           
                                            {/* <th>Confirmed Due Date</th> */}
                                            {/* <th>Created By</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {inventory.map((item, index) => (
                                        <tr key={index}>
                                             {(((mutipleInventoryAccess && userMultipleInventoryAccess) || ciaAccess) && isFilter ) && <td><input type="checkbox" onChange={() => handleCheckboxChange(item)}
    checked={selectedItems.length > 0 && selectedItems.some(tnObj => tnObj.tn === item.tn_number)}  /></td>}
                                        {/* <td><Link to={{ pathname: ``}} >{item.tn_number}</Link></td>   */}
                                        <td>{role  > 2 && status == 2 ? item.tn_number : <a href="#" onClick={(e) => handleNavigation(e, item.id, item.number_type)}>{item.tn_number}</a>}</td>
                                        <td>{item.cname}</td>
                                        <td>{item.did_order == 2 ? "Toll Free" : (item.did_order == 0 ? "Did" : (item.did_order == 3 ? "International" : "-"))}</td>
                                        {role <=2 &&<td>{item.carrier_name}</td>}
                                        <td>{item.tags_id || ""}</td>
                                        <td>{item.cname_label ? item.cname_label : "-"}</td>
                                        {ciaAccess && <td>{item.cas_type == 1 ? 'Enabled' : (item.cas_type == 0 ? 'Disabled' : '-')}</td>}
                                        {role <=2 && <td>{item.note}</td>}
                                        <td>{formatDateTimeToPST(item.created_at, timeZone, role)}</td>
                                        <td>{item.cancel_date ? formatDateTimeToPST(item.cancel_date, timeZone, role) : ""}</td>
                                        {/* <td>{item.status == 0 || item.status == 3 ? "Active" : (item.status == 1 ? "Cancelled" : (item.status == 2 ? 'Others' : "Pending"))}</td> */}
                                        <td>{getNumberStatusLabel(item.status)}</td>
                                       
                                        {/* <td>{item.fname} {item.lname}</td> */}
                                        </tr>))}
                                        {/* <tr>
                                            <td>1571470</td>
                                            <td>TestZoliABS_2023_03_17_19_</td>
                                            <td>Disconnect</td>
                                            <td>04/14/2023</td>
                                            <td><span className="redtxt">Canceled</span></td>
                                            <td>00</td>
                                            <td>04/14/2023</td>
                                            <td>api_user</td>
                                        </tr> */}
                                         </tbody>
                                </table>
                            )}
                                {/* <div className="recored-setup"> */}
                                    {/* <label for="cars">Records Per Page </label>

                                    <select name="cars" id="cars">
                                      <option value="volvo">1</option>
                                      <option value="saab">2</option>
                                      <option value="mercedes">3</option>
                                      <option value="audi">4</option>
                                    </select> */}
                                     {(role > 2 || hasSearched) && totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
 
export default InventoryList